import { combineReducers } from 'redux';

// Reducers
import projectReducer from './project-reducer';
import baseReducer from './base-reducer';
import optionsReducer from './options-reducer';
import { routerReducer } from 'react-router-redux'

// Combine Reducers
var reducers = combineReducers({
  projectState: projectReducer,
  baseState: baseReducer,
  optionsState: optionsReducer,
  routing: routerReducer
});

export default reducers;


/** WEBPACK FOOTER **
 ** ./src/js/reducers/index.js
 **/